const TEMPLATE_NAME = 'RESCHEDULE_PAD';

const initialState = () => ({
  errors: [],
  loading: false,
  pad: {},
  prescriptionContents: [],
  loadedData: [],
  submitData: []
});

const initialArrayOfItemsPrescriptions = prescriptionContents => {
  return prescriptionContents.map(prescriptionContent => {
    return {
      prescriptionContentId: prescriptionContent.id,
      instructionOfUse: prescriptionContent.instructions,
      startDatetime: prescriptionContent.start
    };
  });
};

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = [...action.payload.errors];

      return {
        ...state,
        loading: false,
        errors
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const { pad, prescriptionContents } = action.payload;

      return {
        ...state,
        loading: false,
        pad,
        prescriptionContents,
        loadedData: initialArrayOfItemsPrescriptions(prescriptionContents),
        submitData: []
      };
    }

    case `${TEMPLATE_NAME}_ADD_SUBMIT`: {
      const nPrescriptionContent = action.payload;

      const nPrescriptionContentId = nPrescriptionContent.prescriptionContentId;

      const cPrescriptionContent = state.submitData.find(
        pContent => pContent.prescriptionContentId === nPrescriptionContentId
      );

      let submitData = [...state.submitData];

      if (!cPrescriptionContent) {
        // add submit
        submitData.push(nPrescriptionContent);
      } else {
        // replace submit
        submitData = [...submitData].map(pContent => {
          const cPrescriptionContentId = pContent.prescriptionContentId;
          const nPrescriptionContentId = nPrescriptionContent.prescriptionContentId;
          const itemToBeReplaced = cPrescriptionContentId === nPrescriptionContentId;

          if (itemToBeReplaced) {
            return nPrescriptionContent;
          }

          return pContent;
        });
      }

      return {
        ...state,
        submitData
      };
    }

    case `${TEMPLATE_NAME}_REMOVE_SUBMIT`: {
      const nPrescriptionContent = action.payload;

      const submitData = state.submitData.filter(prescriptionContent => {
        const cPrescriptionContentId = prescriptionContent.prescriptionContentId;
        const nPrescriptionContentId = nPrescriptionContent.prescriptionContentId;

        return cPrescriptionContentId !== nPrescriptionContentId;
      });

      return {
        ...state,
        submitData
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
